
import { connect } from 'react-redux'
import FormList from '../components/FormList'
import { deleteForm, duplicateForm, selectForm, editForm } from '../actions/formList'
import { changeView } from '../actions/main'
import { selectDefaultEditTab } from '../actions/settings'

const mapStateToProps = (state) => ({ 
    forms: state.formList,
    main: state.main 
})

const mapDispatchToProps = dispatch => ({
    deleteForm: id => dispatch(deleteForm(id)),    
    duplicateForm: id => dispatch(duplicateForm(id)),
    selectForm: form => dispatch(selectForm(form)),
    changeView: view => dispatch(changeView(view)),
    getForm: (id, isPreview) => dispatch(editForm(id, isPreview)),
    selectDefaultEditTab: () => dispatch(selectDefaultEditTab())
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FormList)